import React from 'react';
import { Button, Modal } from 'tt-ui-lib/core';
import { GoogleIcon } from 'tt-ui-lib/icons';
import styles from './GoogleAuthModal.module.scss';
import { Link } from 'react-router-dom';

const GoogleAuthModal = ({ open, onClose, onSubmit }) => (
  <Modal
    open={open}
    onClose={() => onClose()}
    onClick={(e) => e.stopPropagation()}
    title="Welcome!"
    className={styles.modalContainer}
  >
    <div className={styles.modalContent}>
      <div className={styles.description}>
        You don&apos;t have an account on TransparentTerra yet. Sign up now as an Individual or
        <Link to="/dashboard/feed" className={styles.learnMore}>
          {' learn more '}
        </Link>
        about TransparenTerra&apos;s roles.
      </div>
      <div className={styles.buttonGroup}>
        <Button type="default" onClick={() => onClose()}>
          cancel
        </Button>
        <Button type="button" className={styles.googleBtn} onClick={() => onSubmit()}>
          <GoogleIcon />
          <div className={styles.signUpText}>Sign up</div>
        </Button>
      </div>
    </div>
  </Modal>
);

export default GoogleAuthModal;
